$(() => {
  const fte_managing_staffing = () => {
    const nurses_on_staff = parseInt($('#nurses-on-staff').val().replace(',', ''), 10);

    return Math.round(nurses_on_staff / 55);
  };

  const run = () => {
    if ($('#fte-managing-staffing-overridden').val() === '0') {
      $('#fte-managing-staffing').val(accounting.formatMoney(fte_managing_staffing(), '', 0));
    }
  };

  run();

  $('#nurses-on-staff').blur(() => {
    run();
  });

  $('#nurses-on-staff').change(() => {
    run();
  });

  $('#fte-managing-staffing').blur(() => {
    $('#fte-managing-staffing-overridden').val('1');
  });
});
